import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { siteConfig } from '../data/mock';

const PrivacyPolicyPage = () => {
  return (
    <main>
      <div className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <ChevronRight size={16} />
            <span>Privacy Policy</span>
          </div>
          <h1 className="display-medium">Privacy Policy</h1>
          <p className="body-large">How we collect, use, and protect your personal information.</p>
        </div>
      </div>

      <section className="section">
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="network-card" style={{ padding: '40px' }}>
            <p className="body-small" style={{ marginBottom: '32px' }}>Last updated: August 2025</p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. Introduction</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              The Grazing Trust (SCIO) (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information when you use our website or services.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. Information We Collect</h2>
            <p className="body-medium" style={{ marginBottom: '12px' }}>We may collect the following types of personal information:</p>
            <ul style={{ paddingLeft: '20px', marginBottom: '24px' }}>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Name and contact details (email, phone number, address)</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Information about horses in your care (for intake enquiries)</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Volunteer application information (skills, experience, availability)</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Donation information (processed securely by our payment provider)</li>
              <li className="body-medium">Website usage data (cookies, analytics)</li>
            </ul>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. How We Use Your Information</h2>
            <p className="body-medium" style={{ marginBottom: '12px' }}>We use your information to:</p>
            <ul style={{ paddingLeft: '20px', marginBottom: '24px' }}>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Respond to enquiries and provide our services</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Process applications (intake, volunteer, rehoming)</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Send updates about our work (with your consent)</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Process donations and issue receipts</li>
              <li className="body-medium">Improve our website and services</li>
            </ul>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Legal Basis for Processing</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              We process your personal data based on: your consent (which you can withdraw at any time), the performance of a contract with you, our legitimate interests in operating the charity, and compliance with legal obligations.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>5. Data Sharing</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              We do not sell your personal information. We may share data with trusted service providers who help us operate (e.g., payment processors, email services), but only where necessary and under strict confidentiality agreements. We may also share information where required by law.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>6. Data Security</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>7. Data Retention</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              We retain personal information only for as long as necessary to fulfil the purposes for which it was collected, or as required by law. Contact records and correspondence are typically retained for 6 years.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>8. Your Rights</h2>
            <p className="body-medium" style={{ marginBottom: '12px' }}>Under data protection law, you have rights including:</p>
            <ul style={{ paddingLeft: '20px', marginBottom: '24px' }}>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Right to access your personal data</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Right to rectification of inaccurate data</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Right to erasure (in certain circumstances)</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Right to restrict processing</li>
              <li className="body-medium" style={{ marginBottom: '8px' }}>Right to data portability</li>
              <li className="body-medium">Right to withdraw consent</li>
            </ul>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>9. Cookies</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              Our website uses cookies to improve your experience and analyse website traffic. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>10. Changes to This Policy</h2>
            <p className="body-medium" style={{ marginBottom: '24px' }}>
              We may update this policy from time to time. Any changes will be posted on this page with an updated revision date.
            </p>

            <h2 className="heading-2" style={{ marginBottom: '16px' }}>11. Contact Us</h2>
            <p className="body-medium" style={{ marginBottom: '12px' }}>For questions about this policy or to exercise your rights, contact us at:</p>
            <p className="body-medium">
              <strong>{siteConfig.name}</strong><br />
              Email: {siteConfig.email}<br />
              {siteConfig.address}
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicyPage;
